"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _translations = _interopRequireDefault(require("./lang/translations.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
_i18next["default"].use(_reactI18next.initReactI18next) // passes i18n down to react-i18next
.init({
  resources: _translations["default"],
  lng: 'es',
  debug: false,
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});
var _default = exports["default"] = _i18next["default"];


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/i18n.js
// module id = 1437
// module chunks = 0